module.exports = __webpack_public_path__ + "img/img (29).557fc302.png";